import React, { Component } from 'react';
import { ClassNames } from '@/utils';
import styles from './index.module.less';

class Index extends Component {
  render () {
    const { id = '', disabled, onClick, width, height, className, type } = this.props;
    return (
      <button
        className={ClassNames([
          styles.globalSubmitBtn,
          className || '',
          disabled ? styles.globalSubmitBtnDisabled : '',
          type ? styles[type] : ''
        ])}
        id={id}
        disabled={disabled}
        style={{
          width: width + 'px',
          height: height + 'px'
        }}
        onClick={onClick}
      >
        {this.props.children}
      </button>
    );
  }
}

export default Index;
